import { getCatalogFiltersFacets } from 'data/api'
import { DynamicFilterReducerAction } from 'pages/Catalog/CatalogProvider/reducers/actionTypes'
import { PriceRange } from 'pages/Catalog/CatalogProvider/types'
import useCatalogContext from 'pages/Catalog/CatalogProvider/useCatalogContext'
import { SelectedDynamicFilterModel } from 'types/models/dynamic-filter'

type FetchDynamicFiltersFacetsParams = {
  selectedDynamicFilters: Array<SelectedDynamicFilterModel>
  selectedTemporaryCatalogIds?: Array<number>
  selectedTemporaryPriceRange?: PriceRange
}

const useFetchDynamicFiltersFacets = () => {
  const { state, dispatch } = useCatalogContext()

  const fetchDynamicFilterFacets = async ({
    selectedDynamicFilters,
    selectedTemporaryCatalogIds,
    selectedTemporaryPriceRange,
  }: FetchDynamicFiltersFacetsParams) => {
    const {
      filters,
      dynamicFilters: { temporaryPriceRange, temporaryCatalogIds },
    } = state

    dispatch({
      type: DynamicFilterReducerAction.FETCH_DYNAMIC_FILTER_FACETS_REQUEST,
      payload: undefined,
    })
    const currentTemporaryCatalogIds = selectedTemporaryCatalogIds ?? temporaryCatalogIds
    const currentTemporaryPriceRange = selectedTemporaryPriceRange ?? temporaryPriceRange

    const response = await getCatalogFiltersFacets({
      ...filters,
      selectedDynamicFilters,
      catalogIds: currentTemporaryCatalogIds,
      priceFrom: currentTemporaryPriceRange.priceFrom,
      priceTo: currentTemporaryPriceRange.priceTo,
    })

    if ('errors' in response) {
      dispatch({
        type: DynamicFilterReducerAction.FETCH_DYNAMIC_FILTER_FACETS_FAILURE,
        payload: { errors: response.errors },
      })
    } else {
      dispatch({
        type: DynamicFilterReducerAction.FETCH_DYNAMIC_FILTER_FACETS_SUCCESS,
        payload: {
          totalCount: response.total_count,
          totalCountMax: response.total_count_max,
        },
      })
    }
  }

  return fetchDynamicFilterFacets
}

export default useFetchDynamicFiltersFacets
